/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiAdminPractitionerIdPasswordResetPost$Params {
  practitionerId: string;
}

export function apiAdminPractitionerIdPasswordResetPost(http: HttpClient, rootUrl: string, params: ApiAdminPractitionerIdPasswordResetPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiAdminPractitionerIdPasswordResetPost.PATH, 'post');
  if (params) {
    rb.path('practitionerId', params.practitionerId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as HealthFindrStrictHttpResponse<void>;
    })
  );
}

apiAdminPractitionerIdPasswordResetPost.PATH = '/api/Admin/{practitionerId}/PasswordReset';
